import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
// import { provideAnimations } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, importProvidersFrom, LOCALE_ID } from '@angular/core'; // ✅ เพิ่ม LOCALE_ID
import { ToastrModule } from 'ngx-toastr';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { credentialsInterceptor } from './app/core/interceptors/credentials.interceptor';
import { ConfigService } from './app/core/services/config.service';
import { environment } from './environments/environment';

// ปิด console ตั้งแต่บูตตาม environment (config.json จะทับอีกทีหลังโหลด)
if (!environment.enableConsoleLog) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

// ✅ ลงทะเบียน locale ก่อน
registerLocaleData(localeEnGb);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRoutes),
    // provideAnimations(),
    provideNoopAnimations(), // ✅ เปลี่ยนตรงนี้
    provideHttpClient(withInterceptors([credentialsInterceptor])),
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => config.load(),
      deps: [ConfigService],
      multi: true,
    },

    // ✅ Set default locale เป็น en-GB → เวลา, วันที่, input time จะกลายเป็น 24 ชม.
    { provide: LOCALE_ID, useValue: 'en-GB' },

    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-center',
        preventDuplicates: false,
      })
    ),
  ],
});
